import { ArrowUpRight } from "lucide-react";
import { useSite, P2P_URL } from "@/lib/site";
import { SOCIALS } from "@/content";
import { Reveal, Kicker } from "./Reveal";
import { ContactForm } from "./ContactForm";

export const Contact = () => {
  const { t } = useSite();
  return (
    <section id="contacto" className="relative overflow-hidden bg-[var(--bg2)] py-24 lg:py-36" data-testid="contact-section">
      <div className="pointer-events-none absolute -bottom-40 left-1/2 h-[480px] w-[900px] -translate-x-1/2 rounded-full bg-[#8B5CF6]/20 blur-[140px]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <Kicker>{t.contact.kicker}</Kicker>
          <h2 className="brand-text brand-glow mt-4 font-display text-6xl font-black tracking-tighter sm:text-8xl lg:text-[9rem] lg:leading-[0.9]">{t.contact.title}</h2>
          <p className="mt-6 max-w-xl text-base text-[var(--muted)] md:text-lg">{t.contact.sub}</p>
        </Reveal>
        <div className="mt-14 grid gap-5 lg:grid-cols-12">
          <Reveal delay={0.1} className="lg:col-span-7">
            <ContactForm />
          </Reveal>
          <Reveal delay={0.2} className="lg:col-span-5">
            <div className="rb-card h-full rounded-3xl p-7 sm:p-9" data-testid="contact-socials-card">
              <p className="font-mono text-xs uppercase tracking-widest text-[var(--muted)]">{t.contact.socials}</p>
              <div className="mt-6 grid grid-cols-2 gap-3">
                {SOCIALS.map((s) => {
                  const Icon = s.icon;
                  return (
                    <a key={s.id} href={s.href} data-testid={`social-${s.id}`} className="pill-outline flex items-center gap-2 rounded-2xl px-4 py-3 text-sm">
                      <Icon className="h-4 w-4 text-[var(--violet-h)]" /> {s.label}
                    </a>
                  );
                })}
              </div>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.25}>
          <a href={P2P_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-p2p-cta" className="group mt-5 flex items-center justify-between gap-4 rounded-3xl border border-[#8B5CF6]/40 bg-[#8B5CF6]/10 p-7 transition-colors hover:bg-[#8B5CF6]/20 sm:p-9">
            <span className="font-display text-2xl font-black tracking-tight sm:text-4xl">{t.ctaP2P}</span>
            <span className="grid h-14 w-14 shrink-0 place-items-center rounded-full bg-[#8B5CF6] text-white transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight className="h-6 w-6" /></span>
          </a>
        </Reveal>
      </div>
    </section>
  );
};
